import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const TRANSLATION_LOADERS = {
  af: () => import('../locales/af/translation.json'),
  ar: () => import('../locales/ar/translation.json'),
  bn: () => import('../locales/bn/translation.json'),
  zh: () => import('../locales/zh/translation.json'),
  'zh-TW': () => import('../locales/zh-TW/translation.json'),
  en: () => import('../locales/en/translation.json'),
  tl: () => import('../locales/tl/translation.json'),
  fr: () => import('../locales/fr/translation.json'),
  de: () => import('../locales/de/translation.json'),
  ha: () => import('../locales/ha/translation.json'),
  hi: () => import('../locales/hi/translation.json'),
  id: () => import('../locales/id/translation.json'),
  it: () => import('../locales/it/translation.json'),
  ja: () => import('../locales/ja/translation.json'),
  km: () => import('../locales/km/translation.json'),
  ko: () => import('../locales/ko/translation.json'),
  lo: () => import('../locales/lo/translation.json'),
  ms: () => import('../locales/ms/translation.json'),
  mm: () => import('../locales/mm/translation.json'),
  pt: () => import('../locales/pt/translation.json'),
  ru: () => import('../locales/ru/translation.json'),
  es: () => import('../locales/es/translation.json'),
  sw: () => import('../locales/sw/translation.json'),
  th: () => import('../locales/th/translation.json'),
  tr: () => import('../locales/tr/translation.json'),
  ur: () => import('../locales/ur/translation.json'),
  vi: () => import('../locales/vi/translation.json')
};

// Chỉ lấy ngôn ngữ từ env đã được worker inject.
const readRuntimeDefaultLanguage = () => {
  if (typeof window === 'undefined') return 'ja';
  return window.QRCODE_ENV?.DEFAULT_LANGUAGE || 'ja';
};
const SUPPORTED_LANGUAGES = new Set([
  'af',
  'ar',
  'bn',
  'zh',
  'zh-TW',
  'en',
  'tl',
  'fr',
  'de',
  'ha',
  'hi',
  'id',
  'it',
  'ja',
  'km',
  'ko',
  'lo',
  'ms',
  'mm',
  'pt',
  'ru',
  'es',
  'sw',
  'th',
  'tr',
  'ur',
  'vi'
]);

const normalizeLanguageCode = (language) => {
  const raw = String(language || '').trim();
  if (!raw) return '';
  const lowered = raw.toLowerCase();
  if (lowered === 'vn') return 'vi';
  if (lowered === 'ind') return 'id';
  if (lowered === 'zh-tw') return 'zh-TW';
  return lowered;
};

const NORMALIZED_DEFAULT_LANGUAGE = normalizeLanguageCode(readRuntimeDefaultLanguage());
const FORCED_LANGUAGE = SUPPORTED_LANGUAGES.has(NORMALIZED_DEFAULT_LANGUAGE)
  ? NORMALIZED_DEFAULT_LANGUAGE
  : 'ja';

const i18nInitialization = i18n
  .use(initReactI18next)
  .init({
    returnNull: false,
    resources: {},
    lng: FORCED_LANGUAGE,
    fallbackLng: FORCED_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false
    },
    // Vô hiệu hóa hoàn toàn auto detection/cache language.
    detection: {
      order: [],
      caches: []
    }
  });

export const loadRuntimeTranslation = async () => {
  await i18nInitialization;
  if (!i18n.hasResourceBundle(FORCED_LANGUAGE, 'translation')) {
    const loader = TRANSLATION_LOADERS[FORCED_LANGUAGE] || TRANSLATION_LOADERS.en;
    const loadedModule = await loader();
    const translation = loadedModule?.default || loadedModule;
    i18n.addResourceBundle(
      FORCED_LANGUAGE,
      'translation',
      translation,
      true,
      true
    );
  }
  await i18n.changeLanguage(FORCED_LANGUAGE);
  return i18n;
};

export default i18n;
